import React from "react";
import { useParams } from "react-router-dom";
import InnerLayout from "../../../components/layouts/inner-layout";
import CreateEInvoice from "../../../components/sales-section/e-invoice/create-e-invoice";

const AddEInvoice = () => {
  const { id } = useParams();

  return (
    <InnerLayout backBtn={true} title="New e-Invoice">
      <CreateEInvoice invoiceId={id} />
    </InnerLayout>
  );
};

export default AddEInvoice;
